import React from 'react';
import Breadcrumb from '../common/Breadcrumb';

const MandatoryPublic = () => {
  return (
    <>
      <Breadcrumb 
        pageTitle="Mandatory Public Disclosure"
        breadcrumbItems={[
          { label: "Home", link: "/" },
          { label: "Mandatory Public Disclosure" }
        ]}
        backgroundImage="images/banner/slide-2.png"
      />
      <style>
        {`         
          .content-wrapper {
            background: #fff;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
            border-radius: 8px;
            padding: 24px;
            margin-bottom: 32px;
          }
          
          .document-title {
            font-size: 28px;
            font-weight: 700;
            color: #333;
          }
          .appendix {
            font-size: 18px;
            font-weight: 600;
            color: #666;
          }
        
          .section-title {
            font-size: 24px;
            font-weight: 600;
            color: #444;
            margin-bottom: 16px;
          }
          .subsection-title {
            font-size: 20px;
            font-weight: 600;
            color: #444;
            margin-bottom: 16px;
          }
          .table-container {
            overflow-x: auto;
          }
          table {
            width: 100%;
            border-collapse: collapse;
            border: 1px solid #ddd;
          }
          th, td {
            border: 1px solid #ddd;
            padding: 12px;
            text-align: left;
            font-size: 14px;
          }
          th {
            background: #f5f5f5;
            font-weight: 600;
            color: #333;
          }
          td {
            color: #555;
          }
          .school-name, .contact-info {
            font-weight: 500;
          }
          .view-btn {
            background: #007bff;
            color: #fff;
            border: none;
            padding: 8px 16px;
            border-radius: 4px;
            cursor: pointer;
            transition: background 0.3s;
          }
          .view-btn:hover {
            background: #0056b3;
          }
          .view-btn.special {
            background: #28a745;
          }
          .view-btn.special:hover {
            background: #1e7e34;
          }
          .percentage {
            color: #28a745;
            font-weight: 500;
          }
          a {
            color: #007bff;
            text-decoration: none;
          }
          a:hover {
            text-decoration: underline;
          }
          @media (max-width: 768px) {            
            .document-title {
              font-size: 24px;
            }
            .appendix {
              font-size: 16px;
            }
            .section-title {
              font-size: 20px;
            }
            .subsection-title {
              font-size: 18px;
            }
            th, td {
              font-size: 12px;
              padding: 8px;
            }
          }
        `}
      </style>
      <section className="space-ptb">
      <div className="container">
        <div className="row align-items-center">
            <div className="col-md-12">
              <div className="section-title mb-4">
                <h2 className="title">
                  <span className="text-primary">Mandatory Public Disclosure</span>
                </h2>
                 <div className="curved-line mx-auto mt-3"></div>
              </div>
            </div>
          </div> 
        <div className="content-wrapper">
          

          <div className="section">
            <h2 className="section-title">A. General Information</h2>
            <div className="table-container">
              <table>
                <thead>
                  <tr>
                    <th>S.No.</th>
                    <th>Information</th>
                    <th>Details</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td>Name of the School</td>
                    <td className="school-name">Pioneer Montessori Inter College</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>Affiliation No. (If Applicable)</td>
                    <td>2132134</td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>School Code (If Applicable)</td>
                    <td>71001</td>
                  </tr>
                  <tr>
                    <td>4</td>
                    <td>Complete Address with Pin Code</td>
                    <td>Sector-3, Eldeco Colony, Udyan-1, Lucknow 226002</td>
                  </tr>
                  <tr>
                    <td>5</td>
                    <td>Principal Name & Qualification</td>
                    <td>Mrs. Sharmila Singh, M.A. (English), B.Ed, PGDCA, PGDHRM</td>
                  </tr>
                  <tr>
                    <td>6</td>
                    <td>School Email ID</td>
                    <td className="contact-info">pioneerdecor@rediffmail.com</td>
                  </tr>
                  <tr>
                    <td>7</td>
                    <td>Contact Details (Landline/Mobile)</td>
                    <td className="contact-info">0522-2446377, 9335606871</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <section className="section">
            <h2 className="section-title">B. Documents and Information</h2>
            <div className="table-container">
              <table>
                <thead>
                  <tr>
                    <th>S.No.</th>
                    <th>Documents/Information</th>
                    <th>Documents</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td>Copies of Affiliation/Upgradation Letter and Recent Extension of Affiliation, If Any</td>
                    <td><button className="view-btn">View</button></td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>Copies of Societies/Trust/Company Registration/Renewal Certificate, as Applicable</td>
                    <td><button className="view-btn">View</button></td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>Copy of No Objection Certificate (NOC) Issued, If Applicable by the State Govt/UT</td>
                    <td><button className="view-btn">View</button></td>
                  </tr>
                  <tr>
                    <td>4</td>
                    <td>Copies of Recognition Certificate Under RTE Act 2009, and Its Renewal If Applicable</td>
                    <td><button className="view-btn">View</button></td>
                  </tr>
                  <tr>
                    <td>5</td>
                    <td>Copy of Valid Building Safety Certificate as per the National Building Code</td>
                    <td><button className="view-btn">View</button></td>
                  </tr>
                  <tr>
                    <td>6</td>
                    <td>Copy of Valid Fire Safety Certificate Issued by the Competent Authority</td>
                    <td><button className="view-btn">View</button></td>
                  </tr>
                  <tr>
                    <td>7</td>
                    <td>Copy of the DEO Certificate Submitted by the School for Affiliation/Upgradation/Extension of Affiliation Self Certification by School</td>
                    <td><button className="view-btn">View</button></td>
                  </tr>
                  <tr>
                    <td>8</td>
                    <td>Copies of Valid Water, Health and Sanitation Certificates</td>
                    <td><button className="view-btn">View</button></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section className="section">
            <h2 className="section-title">C. Result and Academics</h2>
            <div className="table-container">
              <table>
                <thead>
                  <tr>
                    <th>S.No.</th>
                    <th>Documents/Information</th>
                    <th>Documents</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td>Fee Structure of the School</td>
                    <td><button className="view-btn">View</button></td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>Annual Academic Calendar</td>
                    <td><button className="view-btn">View</button></td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>List of School Management Committee (SMC)</td>
                    <td><button className="view-btn">View</button></td>
                  </tr>
                  <tr>
                    <td>4</td>
                    <td>List of Parents Teachers Association (PTA) Members</td>
                    <td><button className="view-btn">View</button></td>
                  </tr>
                  <tr>
                    <td>5</td>
                    <td>Last Three-Year Result of the Board Examination as per Applicability</td>
                    <td><button className="view-btn special">View Below</button></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section className="section">
            <h3 className="subsection-title">Result Class: X</h3>
            <div className="table-container">
              <table>
                <thead>
                  <tr>
                    <th>S.No.</th>
                    <th>Year</th>
                    <th>No. of Registered Students</th>
                    <th>No. of Students Passed</th>
                    <th>Pass Percentage</th>
                    <th>Remarks</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td>2021</td>
                    <td>58</td>
                    <td>58</td>
                    <td><span className="percentage">100%</span></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>2022</td>
                    <td>45</td>
                    <td>45</td>
                    <td><span className="percentage">100%</span></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>2023</td>
                    <td>31</td>
                    <td>31</td>
                    <td><span className="percentage">100%</span></td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section className="section">
            <h3 className="subsection-title">Result Class: XII</h3>
            <div className="table-container">
              <table>
                <thead>
                  <tr>
                    <th>S.No.</th>
                    <th>Year</th>
                    <th>No. of Registered Students</th>
                    <th>No. of Students Passed</th>
                    <th>Pass Percentage</th>
                    <th>Remarks</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td>2021</td>
                    <td>38</td>
                    <td>38</td>
                    <td><span className="percentage">100%</span></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>2022</td>
                    <td>76</td>
                    <td>75</td>
                    <td><span className="percentage">98.68%</span></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>2023</td>
                    <td>59</td>
                    <td>55</td>
                    <td><span className="percentage">93.22%</span></td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section className="section">
            <h2 className="section-title">D. Staff (Teaching)</h2>
            <div className="table-container">
              <table>
                <thead>
                  <tr>
                    <th>S.No.</th>
                    <th>Information</th>
                    <th>Details</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td>Principal</td>
                    <td>01</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>
                      Total No. of Teachers<br />
                      PGT<br />
                      TGT<br />
                      PRT
                    </td>
                    <td>
                      25<br />
                      11<br />
                      05<br />
                      09
                    </td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>Teachers Section Ratio</td>
                    <td>19:01</td>
                  </tr>
                  <tr>
                    <td>4</td>
                    <td>Details of Special Educator</td>
                    <td>-</td>
                  </tr>
                  <tr>
                    <td>5</td>
                    <td>Details of Counselor and Wellness Teacher</td>
                    <td>Mrs. Ekta Chakravorty</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section className="section">
            <h2 className="section-title">E. School Infrastructure</h2>
            <div className="table-container">
              <table>
                <thead>
                  <tr>
                    <th>S.No.</th>
                    <th>Information</th>
                    <th>Details</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td>Total Campus Area of the School (in Square Mtr)</td>
                    <td>6228 Sq. Mtr</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>No. and Size of the Class Rooms (in Sq.Ft/Mtr)</td>
                    <td>40, 48 Sq. Mtr</td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>No. and Size of Laboratories Including Computer Labs (in Sq.Mtr)</td>
                    <td>06, 96 Sq. Mtr</td>
                  </tr>
                  <tr>
                    <td>4</td>
                    <td>Internet Facility (Y/N)</td>
                    <td>Yes</td>
                  </tr>
                  <tr>
                    <td>5</td>
                    <td>No. of Girls Toilets</td>
                    <td>15</td>
                  </tr>
                  <tr>
                    <td>6</td>
                    <td>No. of Boys Toilets</td>
                    <td>15</td>
                  </tr>
                  <tr>
                    <td>7</td>
                    <td>Link of YouTube Video of the Inspection of School Covering the Infrastructure of the School</td>
                    <td>
                      <a href="https://youtu.be/_ukHq_4">View Video</a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>
        </div>
      </div>
      </section>
    </>
  );
};

export default MandatoryPublic;